import { Injectable } from '@angular/core';
import { CreatePaymentMethodPayload, CreatePaymentMethodResponse } from '@core/models/entities/payment-method.models.';
import { environment } from '@environment';
import { HttpApi } from './http.api';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PaymentMethodApi {
  private readonly baseUrl: string = environment.apiUrl;

  constructor(private httpApi: HttpApi) {}

  create(payload: CreatePaymentMethodPayload): Observable<CreatePaymentMethodResponse> {
    return this.httpApi.post(`${this.baseUrl}/payment/method`, payload);
  }
}
